export default __webpack_public_path__ + "static/media/pentesting.a1ad836b.jpg";